import React, { useEffect, useMemo, useRef, useState } from "react";
import moment from "moment";
import { useAppSelector } from "../../app/hooks";
import { axiosApiInstance } from "../../app/axios";
import { API_URL } from "../../app/config";
import FlightRRoute from "./FlightRRoute";
import FlightRPrice from "./FlightRPrice";
import FlightRDetailsTabs from "./FlightRDetailsTabs";
import Loading from "../../components/spinner/Loading";
// import { getNewCabinClassnameFromCode } from "../../_helpers/helper";

interface FlightCardProps {
  route: any;
  selectedFlightPriceId: string;
  routeIndex: number;
  prefix: string;
  handleSelectFlight: (priceDetails: any, route: any, type: string) => void;
}

// this is card is for Round Trip
const FilghtRMainCard = ({
  route,
  routeIndex,
  prefix,
  handleSelectFlight,
  selectedFlightPriceId,
}: FlightCardProps) => {
  const etraveFlightData: any = useAppSelector(
    (state) => state.flight.etraveFlightData
  );

  const flightSearchDetails = useAppSelector(
    (state) => state.home.flightSearchDetails
  );

  const { ADULT, CHILD, INFANT } = flightSearchDetails;

  const sortedPriceList = useMemo(
    () =>
      [...route?.Fares].sort(
        (a, b) =>
          a?.FareDetails[0]?.Total_Amount - b?.FareDetails[0]?.Total_Amount
      ),
    [route?.Fares]
  );
  const [fareRulesLoading, setFareRulesLoading] = useState(false);
  const [openFlightRate, setOpenFlightRate] = useState<boolean>(false);
  const [openFightDetail, setOpenFlightDetail] = useState<boolean>(false);
  const [priceDetails, setPriceDetails] = useState<any>(null);
  const [fareRule, setFareRule] = useState<any>();

  const [adultBaseRate, setAdultBaseRate] = useState(0);
  const [childBaseRate, setChildBaseRate] = useState(0);
  const [infantBaseRate, setInfantBaseRate] = useState(0);

  const [adultTaxRate, setAdultTaxRate] = useState(0);
  const [childTaxRate, setChildTaxRate] = useState(0);
  const [infantTaxRate, setInfantTaxRate] = useState(0);

  const [adultFreeBaggage, setAdultFreeBaggage] = useState({});
  const [childFreeBaggage, setChildFreeBaggage] = useState({});
  const [infantFreeBaggage, setInfantFreeBaggage] = useState({});

  const getFareRules = async (Fare_Id: any, Flight_Key: string) => {
    try {
      setFareRulesLoading(true);
      const Request_Id = sessionStorage.getItem("request_id");
      const response = await axiosApiInstance.post(
        `${API_URL}/AirlineFareRule/Air_FareRule`,
        {
          Fare_Id: Fare_Id,
          Search_Key: etraveFlightData?.Search_Key || "",
          Flight_Key: Flight_Key,
          Request_Id,
        }
      );
      setFareRule(response.data?.FareRules);
    } catch (error) {
      console.error("Error fetching fare rules results:", error);
    } finally {
      setFareRulesLoading(false);
    }
  };

  useEffect(() => {
    if (sortedPriceList) {
      let minPriceOption = route.Fares[0];
      let minPrice = calculateTotalPrice(minPriceOption);

      route.Fares.forEach((fare: any) => {
        const totalPrice = calculateTotalPrice(fare);
        if (totalPrice < minPrice) {
          minPrice = totalPrice;
          minPriceOption = fare;
        }
      });

      setPriceDetails(minPriceOption);
    }
  }, [sortedPriceList]);

  const calculateTotalPrice = (fares: any) => {
    let totalAdultPrice = 0;
    let totalChildPrice = 0;
    let totalInfantPrice = 0;

    fares.FareDetails.forEach((fare: any) => {
      // const totalAmount = fare.Total_Amount || 0;
      const totalAmount =
        (fare.Total_Amount || 0) - (fare.Service_Fee_Amount || 0);

      switch (fare.PAX_Type) {
        case 0:
          totalAdultPrice += totalAmount * ADULT || 0;
          break;
        case 1:
          totalChildPrice += totalAmount * CHILD || 0;
          break;
        case 2:
          totalInfantPrice += totalAmount * INFANT || 0;
          break;
      }
    });

    return totalAdultPrice + totalChildPrice + totalInfantPrice;
  };

  const handleRadioButtonChange = (id: any) => {
    const selectedTp = sortedPriceList.find(
      (fare: any) => fare?.Fare_Id === id
    );
    setPriceDetails(selectedTp);
    if (openFightDetail) {
      getFareRules(id, route?.Flight_Key);
    }
  };

  const handleSelectFlightClick = (
    priceDetails: any,
    route: any,
    prefix: any
  ) => {
    handleSelectFlight(priceDetails, route, prefix);
  };

  const startTime = useMemo(
    () => moment(route?.Segments[0]?.Departure_DateTime),
    [route]
  );
  const endTime = useMemo(
    () =>
      moment(route?.Segments[route?.Segments?.length - 1]?.Arrival_DateTime),
    [route]
  );

  const remainingSeats = priceDetails?.Seats_Available;
  // const cabinClass = priceDetails?.FareDetails[0]?.FareClasses.map(
  //   (fClass: any, index: number) =>
  //     getNewCabinClassnameFromCode(fClass?.Class_Code) +
  //     `${
  //       index + 1 < priceDetails?.FareDetails[0]?.FareClasses?.length
  //         ? ", "
  //         : ""
  //     }`
  // );

  const totalPrice = useMemo(() => {
    if (!priceDetails || !priceDetails.FareDetails) return 0;

    let totalAdultPrice = 0;
    let totalChildPrice = 0;
    let totalInfantPrice = 0;

    let adultBaseRate = 0;
    let childBaseRate = 0;
    let infantBaseRate = 0;

    let adultTaxRate = 0;
    let childTaxRate = 0;
    let infantTaxRate = 0;

    let adultFreeBaggage = {};
    let childFreeBaggage = {};
    let infantFreeBaggage = {};

    priceDetails.FareDetails.forEach((fare: any) => {
      // const totalAmount = fare.Total_Amount || 0;
      const totalAmount =
        (fare.Total_Amount || 0) - (fare.Service_Fee_Amount || 0);
      const BaseAmount = fare.Basic_Amount || 0;
      const TaxAmount = fare.AirportTax_Amount || 0;
      const freeBaggage = fare.Free_Baggage || {};

      switch (fare.PAX_Type) {
        case 0:
          totalAdultPrice += totalAmount * ADULT || 0;
          adultBaseRate += BaseAmount || 0;
          adultTaxRate += TaxAmount || 0;
          adultFreeBaggage = freeBaggage || 0;
          break;
        case 1:
          totalChildPrice += totalAmount * CHILD || 0;
          childBaseRate += BaseAmount || 0;
          childTaxRate += TaxAmount || 0;
          childFreeBaggage = freeBaggage;
          break;
        case 2:
          totalInfantPrice += totalAmount * INFANT || 0;
          infantBaseRate += BaseAmount || 0;
          infantTaxRate += TaxAmount || 0;
          infantFreeBaggage = freeBaggage;
          break;
        default:
          break;
      }
    });

    setAdultBaseRate(adultBaseRate);
    setChildBaseRate(childBaseRate);
    setInfantBaseRate(infantBaseRate);

    setAdultTaxRate(adultTaxRate);
    setChildTaxRate(childTaxRate);
    setInfantTaxRate(infantTaxRate);

    setAdultFreeBaggage(adultFreeBaggage);
    setChildFreeBaggage(childFreeBaggage);
    setInfantFreeBaggage(infantFreeBaggage);

    return totalAdultPrice + totalChildPrice + totalInfantPrice;
  }, [priceDetails, ADULT, CHILD, INFANT]);

  // const totalPrice = priceDetails?.FareDetails[0]?.Total_Amount;

  const closeBtnRef = useRef<any>(null);

  const cancellationCharges =
    (priceDetails?.FareDetails[0] &&
      priceDetails?.FareDetails[0]?.CancellationCharges) ||
    [];
  const rescheduleCharges =
    (priceDetails?.FareDetails[0] &&
      priceDetails?.FareDetails[0]?.RescheduleCharges) ||
    [];

  return (
    <div className="flight-detail-tab">
      <div
        className={`flight-route ${
          selectedFlightPriceId === priceDetails?.Fare_Id
            ? "selected-flight-border"
            : ""
        }`}
      >
        <div className="flight-route-top">
          <FlightRRoute
            route={route}
            startTime={startTime}
            endTime={endTime}
            remainingSeats={remainingSeats}
            openFightDetail={openFightDetail}
            setOpenFlightDetail={setOpenFlightDetail}
          />
          <FlightRPrice
            prefix={prefix}
            openFlightRate={openFlightRate}
            routeIndex={routeIndex}
            setOpenFlightRate={setOpenFlightRate}
            priceDetails={priceDetails}
            sortedPriceList={sortedPriceList}
            handleRadioButtonChange={handleRadioButtonChange}
          />
        </div>
        <div className="detail-btn">
          <div
            className="modal fade"
            id={`farerulepopup_${routeIndex}-${prefix}`}
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex={-1}
            aria-labelledby="edit-profile"
            aria-hidden="true"
          >
            <div
              className="modal-dialog modal-dialog-centered"
              style={{ maxWidth: 991 }}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title fs-5" id="edit-profile">
                    Fare Rule Information
                  </h4>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body travel-form-detail">
                  <Loading loading={fareRulesLoading} />
                  {cancellationCharges?.length <= 0 &&
                  rescheduleCharges?.length <= 0 ? (
                    <>
                      {!fareRulesLoading && (
                        <>
                          {(fareRule && fareRule?.length === 0) ||
                          (fareRule?.length === 1 &&
                            !fareRule[0]?.FareRuleDesc) ? (
                            <h4 className="text-center">
                              {/* No Fare Rule Found. Please contact Customer Care!!! */}
                              Non - Refundable!!!
                            </h4>
                          ) : (
                            <div className="flight-cancel flight-detail flight-table">
                              <h5 className="m-0">
                                {route?.Segments[0]?.Origin_City} {" to "}
                                {
                                  route?.Segments[route?.Segments?.length - 1]
                                    ?.Destination_City
                                }
                              </h5>
                              <span className="mention-tag">
                                Mentioned fees are Per Pax Per Sector <br />{" "}
                                Apart from airline charges, GST + RAF +
                                applicable charges if any, will be charged.
                              </span>
                              <div style={{ maxHeight: 400, overflow: "auto" }}>
                                {fareRule?.map((e: any) => {
                                  return (
                                    <div
                                      style={{ padding: "0 10px" }}
                                      dangerouslySetInnerHTML={{
                                        __html: e?.FareRuleDesc ?? "",
                                      }}
                                    />
                                  );
                                })}
                              </div>
                              <span className="d-block">
                                *From the Time of Departure
                              </span>
                              <span>*Service charge will be extra</span>
                            </div>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <div
                      style={{
                        maxHeight: "calc(100vh - 300px)",
                        overflowY: "auto",
                        scrollbarWidth: "thin",
                      }}
                    >
                      {cancellationCharges?.length > 0 && (
                        <div className="cancel-wrapper">
                          <div className="cancel-table-container">
                            <table className="cancel-table">
                              <thead>
                                <tr>
                                  <th colSpan={5} className="cancel-th">
                                    <h4>Cancellation Charges</h4>
                                  </th>
                                </tr>
                                <tr>
                                  <th className="cancel-th">#</th>
                                  <th className="cancel-th">Applicability</th>
                                  <th className="cancel-th">Passenger Type</th>
                                  <th className="cancel-th">Duration</th>
                                  <th className="cancel-th">Charge</th>
                                </tr>
                              </thead>
                              <tbody>
                                {cancellationCharges?.map(
                                  (cCharge: any, index: number) => {
                                    return (
                                      <tr className="cancel-row">
                                        <td className="cancel-td">
                                          {index + 1}
                                        </td>
                                        <td className="cancel-td">
                                          <span className="cancel-pill">
                                            Per{" "}
                                            {cCharge?.Applicablility === 0
                                              ? "Segment"
                                              : "Passenger"}
                                          </span>
                                        </td>
                                        <td className="cancel-td">
                                          {cCharge?.PassengerType === 0
                                            ? "Adult"
                                            : cCharge?.PassengerType === 1
                                            ? "Child"
                                            : "Infant"}
                                        </td>
                                        <td className="cancel-td">
                                          {cCharge?.DurationFrom}{" "}
                                          {cCharge?.DurationTypeFrom === 0
                                            ? "Hr(s) "
                                            : cCharge?.DurationTypeFrom === 1
                                            ? "days "
                                            : ""}
                                          – {cCharge?.DurationTo}{" "}
                                          {cCharge?.DurationTypeTo === 0
                                            ? "Hr(s)"
                                            : cCharge?.DurationTypeTo === 1
                                            ? "days"
                                            : ""}
                                        </td>
                                        <td className="cancel-td">
                                          {+cCharge?.Value === 0 ? (
                                            "Non Chargeable"
                                          ) : +cCharge?.Value === 100 &&
                                            cCharge?.ValueType === 1 ? (
                                            "Non Refundable"
                                          ) : (
                                            <>
                                              {cCharge?.ValueType === 0
                                                ? "₹ "
                                                : ""}
                                              {cCharge?.Value}
                                              {cCharge?.ValueType === 1
                                                ? "%"
                                                : ""}
                                            </>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                                <tr className="cancel-row">
                                  <td className="cancel-td" colSpan={5}>
                                    <strong className="d-block">
                                      *From the Time of Departure
                                    </strong>
                                    <strong>
                                      *Service charge will be extra
                                    </strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                      {rescheduleCharges?.length > 0 && (
                        <div className="cancel-wrapper">
                          <div className="cancel-table-container">
                            <table className="cancel-table">
                              <thead>
                                <tr>
                                  <th colSpan={5} className="cancel-th">
                                    <h4>Reschedule Charges</h4>
                                  </th>
                                </tr>
                                <tr>
                                  <th className="cancel-th">#</th>
                                  <th className="cancel-th">Applicability</th>
                                  <th className="cancel-th">Passenger Type</th>
                                  <th className="cancel-th">Duration</th>
                                  <th className="cancel-th">Charge</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rescheduleCharges?.map(
                                  (rCharge: any, index: number) => {
                                    return (
                                      <tr className="cancel-row">
                                        <td className="cancel-td">
                                          {index + 1}
                                        </td>
                                        <td className="cancel-td">
                                          <span className="cancel-pill">
                                            Per{" "}
                                            {rCharge?.Applicablility === 0
                                              ? "Segment"
                                              : "Passenger"}
                                          </span>
                                        </td>
                                        <td className="cancel-td">
                                          {rCharge?.PassengerType === 0
                                            ? "Adult"
                                            : rCharge?.PassengerType === 1
                                            ? "Child"
                                            : "Infant"}
                                        </td>
                                        <td className="cancel-td">
                                          {rCharge?.DurationFrom}{" "}
                                          {rCharge?.DurationTypeFrom === 0
                                            ? "Hr(s) "
                                            : rCharge?.DurationTypeFrom === 1
                                            ? "days "
                                            : ""}{" "}
                                          – {rCharge?.DurationTo}{" "}
                                          {rCharge?.DurationTypeTo === 0
                                            ? "Hr(s)"
                                            : rCharge?.DurationTypeTo === 1
                                            ? "days"
                                            : ""}
                                        </td>
                                        <td className="cancel-td">
                                          {+rCharge?.Value === 0 ? (
                                            "Non Chargeable"
                                          ) : +rCharge?.Value === 100 &&
                                            rCharge?.ValueType === 1 ? (
                                            "Non Refundable"
                                          ) : (
                                            <>
                                              {rCharge?.ValueType === 0
                                                ? "₹ "
                                                : ""}
                                              {rCharge?.Value}
                                              {rCharge?.ValueType === 1
                                                ? "%"
                                                : ""}
                                            </>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                                <tr className="cancel-row">
                                  <td className="cancel-td" colSpan={5}>
                                    <strong className="d-block">
                                      *From the Time of Departure
                                    </strong>
                                    <strong>
                                      *Service charge will be extra
                                    </strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  <div className="travel-detail-btns mt-4">
                    <a
                      className="btn disable"
                      href="javascript:void(0)"
                      data-bs-dismiss="modal"
                      ref={closeBtnRef}
                    >
                      Close
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a
            className="fill-btn"
            onClick={() => handleSelectFlightClick(priceDetails, route, prefix)}
          >
            {selectedFlightPriceId === priceDetails?.Fare_Id
              ? "Selected"
              : "Select Flight"}
          </a>
          <strong
            className="fare-rule-btn ms-2"
            data-bs-toggle="modal"
            data-bs-target={`#farerulepopup_${routeIndex}-${prefix}`}
            onClick={() => {
              if (
                cancellationCharges?.length <= 0 &&
                rescheduleCharges?.length <= 0
              ) {
                getFareRules(priceDetails?.Fare_Id, route?.Flight_Key);
              }
            }}
          >
            Fare Rules
          </strong>
        </div>
      </div>
      {/* flight-outer-open */}
      <FlightRDetailsTabs
        openFightDetail={openFightDetail}
        routeIndex={routeIndex}
        prefix={prefix}
        route={route}
        priceDetails={priceDetails}
        // classOfBook={classOfBook}
        // cabinClass={cabinClass}
        remainingSeats={remainingSeats}
        getFareRules={getFareRules}
        ADULT={ADULT}
        adultTaxRate={adultTaxRate}
        adultBaseRate={adultBaseRate}
        CHILD={CHILD}
        childTaxRate={childTaxRate}
        childBaseRate={childBaseRate}
        INFANT={INFANT}
        infantTaxRate={infantTaxRate}
        infantBaseRate={infantBaseRate}
        totalPrice={totalPrice}
        fareRule={fareRule}
        fareRulesLoading={fareRulesLoading}
        adultFreeBaggage={adultFreeBaggage}
        childFreeBaggage={childFreeBaggage}
        infantFreeBaggage={infantFreeBaggage}
      />
    </div>
  );
};

export default FilghtRMainCard;
